import { Action } from '@ngrx/store';

import { User, Login } from './auth.model';

export enum AuthActionTypes {
  LOGIN = '[Auth] Login',
  LOGOUT = '[Auth] Logout',
  LOGIN_SUCCESS = '[Auth] Login Success',
  LOGIN_FAILURE = '[Auth] Login Failure',
  USER_LOADED = '[Auth User] Loaded',
  USER_REQUESTED = '[Auth User] Requested',
}

export class LogIn implements Action {
  readonly type = AuthActionTypes.LOGIN;
  constructor(public payload :any) {}
}

export class LogOut implements Action {
  readonly type = AuthActionTypes.LOGOUT;
  constructor() {}
}

export class LogInSuccess implements Action {
  readonly type = AuthActionTypes.LOGIN_SUCCESS;
  constructor(public payload :Login) {}
}

export class LogInFailure implements Action {
  readonly type = AuthActionTypes.LOGIN_FAILURE;
  constructor(public payload :any) {}
}

export class UserLoaded implements Action {
  readonly type = AuthActionTypes.USER_LOADED;
  constructor(public payload :User) {}
}

export class UserRequested implements Action {
  readonly type = AuthActionTypes.USER_REQUESTED;
}

export type AuthActions =
  | LogIn
  | LogOut
  | LogInSuccess
  | LogInFailure
  | UserLoaded
  | UserRequested;
